import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, BehaviorSubject, Subject, of } from "rxjs";
import { User, UserProfile } from "../_models/User";
import { environment } from "../../environments/environment";
import { Router } from "@angular/router";
import { map, tap } from "rxjs/operators";
import { LoginResponse } from "../types/userAndRoles";

@Injectable({
  providedIn: "root",
})
export class AuthenticationService {
  private _currentUser: BehaviorSubject<User> = new BehaviorSubject<User>(null);
  public currentUser$ = this._currentUser.asObservable();
  constructor(private http: HttpClient, private router: Router) {
    this._currentUser.next(this.getCurrentUserValue());
  }

  public getCurrentUserValue(): User {
    let user = localStorage.getItem("currentUser");
    if (user) {
      return JSON.parse(user);
    }
    return null;
  }

  public setCurrentUserValue(user: User | null) {
    this._currentUser.next(user);
    localStorage.setItem("currentUser", JSON.stringify(user));
    localStorage.setItem("userToken", JSON.stringify(user.token));
  }
  loginUser2(values: {
    email: string;
    password: string;
  }): Observable<LoginResponse> {
    return this.http.post(`${environment.API_URL_V2}/auth/login`, {
      ...values,
    }) as Observable<LoginResponse>;
  }

  loginUser(values: {
    email: string;
    password: string;
  }): Observable<LoginResponse> {
    return this.http.post(
      `${environment.API_URL_V3}/auth/login`,{...values}
    ) as Observable<LoginResponse>;
  }

  logout() {
    this._currentUser.next(null);
    localStorage.removeItem("currentUser");
    localStorage.removeItem("userToken");
    this.router.navigate(["/"]);
  }

  isLoggedIn$() {
    return this.currentUser$.pipe(map((user) => (user ? true : false)));
  }

  isSuperAdmin$() {
    return this.currentUser$.pipe(map((user) => user && user.is_super_admin));
  }
  isOrderAdmin$() {
    let isadmin = false;
    this.currentUser$.pipe(
      map((user) => {
        if (
          user &&
          user.permissions.includes("orders.update_items_after_confirmation")
        ) {
          isadmin = true;
        }
      })
    );
    return isadmin;
  }
  public forgotPassword(email: string) {
    return this.http.post(`${environment.API_URL_V2}/auth/forgot-password`, {
      email,
      domain: environment.API_URL_V2,
    });
  }

  public getProfile(): Observable<UserProfile> {
    return this.http.get(`${environment.API_URL_V2}/auth/profile`).pipe(
      tap((user: UserProfile) => {
        this._currentUser.next({ ...this._currentUser.value, ...user });
      })
    ) as Observable<UserProfile>;
  }

  change_password(values: {
    old_password: string;
    new_password: string;
  }): Observable<any> {
    return this.http.post(`${environment.API_URL_V2}/auth/change-password`, {
      ...values,
    });
  }
}
